import React from 'react';
import { motion } from 'framer-motion';
import { Clock, ArrowRight } from 'lucide-react';
export function UrgencyClose() {
  return <section className="py-24 px-6 bg-brand-navy text-white text-center relative overflow-hidden" data-id="element-89">
      <div className="absolute inset-0 opacity-20 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-brand-accent to-transparent" data-id="element-90"></div>
      <div className="absolute top-10 left-10 w-32 h-32 bg-brand-accent/20 rounded-full blur-3xl" data-id="element-91"></div>
      <div className="absolute bottom-10 right-10 w-48 h-48 bg-brand-accentLight/20 rounded-full blur-3xl" data-id="element-92"></div>

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-93">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-94">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-brand-accent mb-8 shadow-lg shadow-brand-accent/40" data-id="element-95">
            <Clock className="w-8 h-8 text-white" data-id="element-96" />
          </div>

          <h2 className="text-3xl md:text-5xl font-black uppercase mb-10 leading-tight" data-id="element-97">
            Pregunta <span className="text-brand-accentLight" data-id="element-98">importante</span>
          </h2>

          <div className="space-y-6 text-xl md:text-2xl font-serif italic text-white/90 mb-12" data-id="element-99">
            <p data-id="element-100">¿Cuánto tiempo te tomaría descubrir todo esto por tu cuenta?</p>
            <p data-id="element-101">
              ¿Cuántas horas de prueba y error podrías evitar teniendo una guía
              paso a paso?
            </p>
          </div>

          <p className="text-lg md:text-xl text-white/80 mb-12 font-medium" data-id="element-102">
            Hoy tienes la oportunidad de acceder a todo el proceso en un solo
            lugar.
          </p>

          <motion.a href="https://shop.beacons.ai/byesthermaria/Ebooks" target="_blank" rel="noopener noreferrer" whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="inline-flex items-center justify-center gap-3 bg-brand-accent hover:bg-brand-accentHover text-white px-10 py-5 rounded-2xl font-black text-lg transition-colors shadow-xl shadow-brand-accent/40 w-full sm:w-auto uppercase" data-id="element-103">
            Quiero crear mi producto digital
            <ArrowRight className="w-5 h-5" data-id="element-104" />
          </motion.a>
        </motion.div>
      </div>
    </section>;
}